import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
//components
import ModalRegister from "../../../../components/modal/ModalRegister/ModalRegister";
//utils
import { api } from "../../../../utils/api";
import { queryClient } from "../../../../utils/queryClient";

export const ModalCompleteRegister = ({
  onHide,
  leadId,
  visible,
  baseData,
  setVisible,
  movePayload,
  refetchLeads,
  patchLeadStatus,
}) => {
  const [access, setAccess] = useState(null);
  const [errors, setErrors] = useState(null);
  const [address, setAddress] = useState(null);
  const [loading, setloading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [telephones, setTelephones] = useState([]);
  const [personalData, setPersonalData] = useState(null);
  const [typeRegister, setTypeRegister] = useState("fisica");
  const [errorsVisible, setErrorsVisible] = useState(false);

  useEffect(() => {
    if (access) {
      setAccess(access);
    }
    if (personalData) {
      setPersonalData(personalData);
    }
    if (address) {
      setAddress(address);
    }
    if (documents.length > 0) {
      setDocuments(documents);
    }
    if (telephones.length > 0) {
      setTelephones(telephones);
    }
    if (contacts.length > 0) {
      setContacts(contacts);
    }
  }, [access, personalData, address, documents, telephones, contacts]);

  const handleSubmit = async (data) => {
    // console.log("Dados de Access:", data);
    setloading(true);
    const updatedData = {
      ...data,
      lead_id: leadId,
    };
    const notification = toast.loading("Por favor aguarde...");
    try {
      const response = await api.post("register-general", updatedData);
      if (response.data) {
        toast.update(notification, {
          render: response.data.success,
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      }

      const notificationMove = toast.loading("Movendo lead...");
      try {
        await patchLeadStatus(movePayload);
        refetchLeads();
        toast.update(notificationMove, {
          render: "Lead movido com sucesso!",
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 2000,
        });
      } catch (error) {
        // setFunnel(previousFunnel);
        toast.update(notificationMove, {
          render: "Erro ao mover lead!",
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 2000,
        });
      }
      setVisible(false);
      setloading(false);
    } catch (e) {
      setloading(false);
      // console.log(e.response.data.errors);
      setErrors(e.response.data.errors);
      setErrorsVisible(true);
      toast.update(notification, {
        render: "Falha ao salvar informações!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
      throw e;
    } finally {
      setloading(false);
    }
  };

  return (
    <>
      <ModalRegister
        errors={errors}
        leadId={leadId}
        onHide={onHide}
        access={access}
        loading={loading}
        visible={visible}
        address={address}
        baseData={baseData}
        contacts={contacts}
        setAccess={setAccess}
        documents={documents}
        setVisible={setVisible}
        telephones={telephones}
        setAddress={setAddress}
        setContacts={setContacts}
        typeRegister={typeRegister}
        setDocuments={setDocuments}
        personalData={personalData}
        handleSubmit={handleSubmit}
        setTelephones={setTelephones}
        errorsVisible={errorsVisible}
        setPersonalData={setPersonalData}
        setTypeRegister={setTypeRegister}
        setErrorsVisible={setErrorsVisible}
      />
    </>
  );
};
